import { logger } from '@/util';
import { DomainCode } from '@australiangreens/ag-internal-components';
import callBackendApi from './call';

export interface BranchRecord {
  id: number;
  label: string;
  value: number;
  state?: string; // Undefined if not in a state, which should not happen.
}

export const getBranches = async (
  token: string,
  state: string, // Empty if all states and territories are selected.
  searchValue: string, // Empty if there is no value to search for.
  abortSignal?: AbortSignal
) => {
  // logger.debug('getBranches() called', { state, searchValue });

  let endpoint;

  const searchValueEncoded = encodeURIComponent(searchValue);

  if (searchValue) {
    endpoint = state
      ? `/branches?state=${state}&value=${searchValueEncoded}`
      : `/branches?value=${searchValueEncoded}`;
  } else {
    endpoint = state ? `/branches?state=${state}` : `/branches/`;
  }

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: endpoint,
    abortSignal,
  });

  return data as BranchRecord[];
};

export const getBranchById = async (token: string, branchId: number, abortSignal?: AbortSignal) => {
  logger.debug('getBranchById() called', {});

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/branches/${branchId}`,
    abortSignal,
  });
  return data as BranchRecord;
};

export const getBranchesById = async (
  token: string,
  branchIds: number[],
  domainCode: DomainCode,
  abortSignal?: AbortSignal
) => {
  logger.debug('getBranchesById() called', {});

  const state = ['ag', 'fedmps'].includes(domainCode) ? '' : domainCode.toUpperCase();

  const data = await callBackendApi({
    token,
    method: 'get',
    endpoint: `/branches/?ids=${JSON.stringify(branchIds)}${state === '' ? '' : `&state=${state}`}`,
    abortSignal,
  });
  return data as BranchRecord[];
};
